import React, { useEffect, useState } from "react";
import * as loadingAction from "../../../../store/loading/action";
import * as messageAction from "../../../../store/message/action";

import {
    GET_RP_QUALITY,
    GET_RP_FUEL_CONSUMPTION,
    GET_RP_FUEL_CRITERIA,
    GET_DT_DAILY_FLOW_PLAN
} from "../../../../helpers/url_api_constant";

import {
    Card,
    CardBody,
    Col,
    Input,
    Row,
    Table,
} from "reactstrap";


import { post } from "helpers/api_helper";
import PropTypes from "prop-types";
import moment from "moment";
import { useDispatch } from "react-redux";
import BarChartQtyAndComFuel from "../SectionQtyAndComFuel/BarChartQtyAndComFuel";

function SectionQtyAndComFuel(props) {
    // console.log(props);
    function numberFormat(number, digit = 2) {
        if (number === null || number === "null" || number === "") return "";
        function isFloat(n) {
            return Number(n) === n && n % 1 !== 0;
        }
        if (isFloat(number))
            return parseFloat(number.toFixed(digit)).toLocaleString(undefined, {
                minimumFractionDigits: digit,
            });
        return parseFloat(number).toLocaleString(undefined, {
            minimumFractionDigits: digit,
        });
    }

    const dispatch = useDispatch();

    const defaultQtyModel = {
        PID: "",
        SUMMARYREPORT_PID: props.summaryReportPid,
        QUALITY_STATUS: 0,
        OFFSHORE_STATUS: false,
        OFFSHORE_REMARK: "",
        EAST_STATUS: false,
        EAST_REMARK: "",
        WEST_STATUS: false,
        WEST_REMARK: "",
        EASTWEST_STATUS: false,
        EASTWEST_REMARK: "",
        SOUTH_STATUS: false,
        SOUTH_REMARK: "",
        STATUS_FLAG: 0,
        DELETE_FLAG: 0,
    };

    const modelConsumptionList = {
        ACCUM_ACTUAL: 0,
        ACCUM_END: "",
        ACCUM_START: "",
        ACCUM_TARGET: 0,
        CAUSE_REMARK: "",
        DAILY_FLOW: 0,
        FUEL_ACTUAL: 0,
        FUEL_DATE: "",
        FUEL_ELEC: 0,
        FUEL_GAS: 0,
        FUEL_TARGET: 0,
        FUEL_DIFF: 0,
        ACCUM_DIFF: 0,
        VALIDATE_FLAG: false,
    };

    const [rpFuelConsumptionListModel, setRPFuelConsumptionListModel] = useState(modelConsumptionList);
    const [modelDeviceList, setModelDeviceList] = useState([]);
    const [qtyModel, setQtyModel] = useState(defaultQtyModel);
    const [dataListGraphRpFuel, setDataListGraphRpFuel] = useState([]);
    const [dailyTargetPlan, setDailyTargetPlan] = useState([]);
    const [showValueCriteria, setShowValueCriteria] = useState({ SHOW_TEXT: "-", VALUE_CRITERIA_TODAY: 0 });

    const fetchData = async () => {
        let dataRPFuel = {};
        let dataDialogCriteria = [];
        let calculate = "";
        let flagValidate = false;
        dispatch(loadingAction.showLoading());
        setQtyModel(defaultQtyModel);
        try {

            let [quality, resCriteria, resRP, resGraph, resFuelTarget] = await Promise.all([
                post(GET_RP_QUALITY, { SUMMARYREPORT_PID: props.summaryReportPid || "f126e98a-3529-4a47-b497-4cba630d6682", }),
                post(GET_RP_FUEL_CRITERIA, {}),
                post(GET_RP_FUEL_CONSUMPTION, { SUMMARYREPORT_PID: props.summaryReportPid || "f126e98a-3529-4a47-b497-4cba630d6682" }),
                post(GET_RP_FUEL_CONSUMPTION, { REPORT_DATE: moment(props.date).format("YYYY-MM-DD") }),
                post(GET_DT_DAILY_FLOW_PLAN, {
                    DAILYFLOWPLAN_PRE30_DATE: moment(props.date).format(
                        "YYYY-MM-DD"
                    ),
                }),
            ]);

            dataDialogCriteria = resCriteria.data.RPFuelCriteriaList;
            // console.log(dataDialogCriteria);

            if (resRP.data.RPFuelConsumptionList.length == 1) {
                dataRPFuel = resRP.data.RPFuelConsumptionList[0];
                calculate = (dataRPFuel.FUEL_ACTUAL - dataRPFuel.FUEL_TARGET).toFixed(0);
            } else {
                dataRPFuel = modelConsumptionList;
            };

            if (resGraph.resultCode == 200) {
                setDataListGraphRpFuel(resGraph.data.RPFuelConsumptionList.map(obj => ({
                    ...obj, SUM_FUEL: (obj.FUEL_ACTUAL - obj.FUEL_TARGET).toFixed(0)
                })));
            }

            // console.log(resFuelTarget);
            if (resFuelTarget.data != null) {
                setDailyTargetPlan(resFuelTarget.data.dtDailyFlowPlanList);
            } else {
                setDailyTargetPlan([]);
            }

            let dataRangeCriteria = dataDialogCriteria.find(item => {
                // console.log("start", moment(item.START_DATE).toDate(), "end", moment(item.END_DATE).toDate(), "fuel date", moment(data.FUEL_DATE).toDate());
                // console.log(moment(item.START_DATE).toDate() <= moment(data.FUEL_DATE).toDate() && item.END_DATE == null);
                if (moment(item.END_DATE).toDate() >= moment(dataRPFuel.FUEL_DATE).toDate() && moment(item.START_DATE).toDate() <= moment(dataRPFuel.FUEL_DATE).toDate()) {
                    return true;
                } else if (moment(item.START_DATE).toDate() <= moment(dataRPFuel.FUEL_DATE).toDate() && item.END_DATE == "" || item.END_DATE == null) {
                    return true;
                }
                return false;
            })

            if (dataRangeCriteria != undefined && dataRangeCriteria != "" && dataRangeCriteria != null) {
                setShowValueCriteria({
                    // SHOW_TEXT: "*บังคับต้องการกรอกค่า เมื่อ Target และ Actual รายวันแตกต่างกันเกิน " + dataRangeCriteria.COMPRESSOR_CRITERIA + " (สามารถปรับค่าได้)", ของเดิม
                    SHOW_TEXT: "-",
                    VALUE_CRITERIA_TODAY: dataRangeCriteria.COMPRESSOR_CRITERIA
                });

                if (calculate > dataRangeCriteria.COMPRESSOR_CRITERIA) {
                    // setRPFuelConsumptionListModel({ ...dataRPFuel, FUEL_DIFF: calculate, VALIDATE_FLAG: true })
                    flagValidate = true;
                }
            }

            setRPFuelConsumptionListModel({ ...dataRPFuel, FUEL_DIFF: calculate, VALIDATE_FLAG: flagValidate })

            if (quality.data.rpQualityList.length == 1) {
                setQtyModel(quality.data.rpQualityList[0]);
            }

        } catch (error) {
            dispatch(messageAction.showMessage(error.message));
        }
        dispatch(loadingAction.hideLoading());
    };

    useEffect(() => {
        fetchData();

    }, [props.summaryReportPid]);

    // useEffect(() => {
    //     console.log(showValueCriteria.VALUE_CRITERIA_TODAY);
    //     console.log(rpFuelConsumptionListModel.FUEL_DIFF);
    // }, [rpFuelConsumptionListModel.FUEL_DIFF]);

    return (
        <Row>

            <Row className="mt-0">
                <Col sm="6">
                    <h5 className="mb-0 sm-0" style={{ color: "#FFFFFF", fontWeight: "bold", fontSize: "1.1vw" }}> Quality and Compressor Fuel</h5>
                </Col>
                <Col sm="6">
                    <h5
                        className="mb-0 sm-0 d-flex align-items-center justify-content-end"
                        style={{ color: "#FFFFFF", fontWeight: "bold", fontSize: "1.1vw" }}
                    >
                        Gas Day : {moment(props.date).locale("en").format("DD MMM YYYY")}
                    </h5>
                </Col>
            </Row>

            <Row className="mt-2">
                <hr />
            </Row>

            <div className="d-flex dashboard-content-body">
                <div className="d-flex" style={{ flex: 1.5 }}>
                    <div className="d-flex flex-column" style={{ flex: 1, paddingRight: 3, position: "relative" }}>
                        <Row>
                            <Col sm="2">
                                <h5 style={{ fontSize: "2vh", fontWeight: "bold" }}> Quality </h5>
                            </Col>
                            <Col sm="2">
                                <h5 style={{ fontSize: "2vh", fontWeight: "bold", color: qtyModel.QUALITY_STATUS == 1 ? "#FF4545" : "#6EF649" }}> {qtyModel.QUALITY_STATUS == 1 ? "Abnormal" : "Normal"} </h5>
                            </Col>
                        </Row>
                        <Table className="table table-bordered mb-0">
                            <thead style={{ backgroundColor: "#466597", color: "#FEF6AA", textAlign: "center", fontSize: "1.9vh", fontWeight: "bold" }}>
                                <tr>
                                    <th style={{ width: "15%" }}>Quality</th>
                                    <th style={{ width: "10%" }}>Status</th>
                                    <th style={{ width: "25%" }}>Remark</th>
                                </tr>
                            </thead>
                            <tbody style={{ color: "#FFFFFF", textAlign: "center", fontSize: "1.9vh", fontWeight: "bold" }}>
                                <tr style={{ height: "10vh" }}>
                                    <td>Offshore</td>
                                    <td style={{ color: qtyModel.OFFSHORE_STATUS == 1 ? "#FF4545" : "#6EF649" }}>
                                        {qtyModel.OFFSHORE_STATUS == 1 ? "Abnormal" : "Normal"} </td>
                                    <td style={{ fontSize: "1.7vh" }}>{qtyModel.OFFSHORE_REMARK}</td>
                                </tr>
                                <tr style={{ height: "10vh" }}>
                                    <td>East</td>
                                    <td style={{ color: qtyModel.EAST_STATUS == 1 ? "#FF4545" : "#6EF649" }}>
                                        {qtyModel.EAST_STATUS == 1 ? "Abnormal" : "Normal"} </td>
                                    <td style={{ fontSize: "1.7vh" }}>{qtyModel.EAST_REMARK}</td>
                                </tr>
                                <tr style={{ height: "10vh" }}>
                                    <td>West</td>
                                    <td style={{ color: qtyModel.WEST_STATUS == 1 ? "#FF4545" : "#6EF649" }}>
                                        {qtyModel.WEST_STATUS == 1 ? "Abnormal" : "Normal"} </td>
                                    <td style={{ fontSize: "1.7vh" }}>{qtyModel.WEST_REMARK}</td>
                                </tr>
                                <tr style={{ height: "10vh" }}>
                                    <td>East West</td>
                                    <td style={{ color: qtyModel.EASTWEST_STATUS == 1 ? "#FF4545" : "#6EF649" }}>
                                        {qtyModel.EASTWEST_STATUS == 1 ? "Abnormal" : "Normal"} </td>
                                    <td style={{ fontSize: "1.7vh" }}>{qtyModel.EASTWEST_REMARK}</td>
                                </tr>
                                <tr style={{ height: "10vh" }}>
                                    <td>South</td>
                                    <td style={{ color: qtyModel.SOUTH_STATUS == 1 ? "#FF4545" : "#6EF649" }}>
                                        {qtyModel.SOUTH_STATUS == 1 ? "Abnormal" : "Normal"} </td>
                                    <td style={{ fontSize: "1.7vh" }}>{qtyModel.SOUTH_REMARK}</td>
                                </tr>
                            </tbody>
                        </Table>
                    </div>


                    <div className="d-flex flex-column" style={{ flex: 1, paddingLeft: 2, position: "relative", borderLeft: "solid 2px #4A5576" }}>
                        <h4 className="ms-2" style={{ fontSize: "2vh", fontWeight: "bold" }}>Compressor Fuel Consumption ( Flow Per Fuel)</h4>
                        <div className="mt-0" style={{ width: "100%", position: 'relative', height: "48%" }}>
                            <BarChartQtyAndComFuel data={dataListGraphRpFuel} date={props.date} summaryReportPid={props.summaryReportPid} targetPlan={dailyTargetPlan} />
                        </div>
                        <Table className="table table-bordered mb-0">
                            <thead>
                                <tr>
                                    <th colSpan={7} style={{ backgroundColor: "#466597", color: "#FEF6AA", textAlign: "center", width: "100%", fontSize: "1.7vh", fontWeight: "bold" }}>Compressor Fuel Consumption</th>
                                </tr>
                                <tr style={{ fontSize: "1.7vh" }}>
                                    <th style={{ backgroundColor: "#466597", color: "#FEF6AA", textAlign: "center", width: "20%", fontWeight: "bold" }}>Flow/Fuel (MMSCF/BBTU)</th>
                                    <th style={{ backgroundColor: "#466597", color: "#FEF6AA", textAlign: "center", width: "15%", fontWeight: "bold" }}>Target</th>
                                    <th style={{ backgroundColor: "#466597", color: "#FEF6AA", textAlign: "center", width: "15%", fontWeight: "bold" }}>Actual</th>
                                    <th style={{ backgroundColor: "#466597", color: "#FEF6AA", textAlign: "center", width: "15%", fontWeight: "bold" }}>Diff</th>
                                    <th style={{ backgroundColor: "#466597", color: "#FEF6AA", textAlign: "center", width: "35%", fontWeight: "bold" }}>Cause</th>
                                </tr>
                            </thead>
                            <tbody style={{ color: "#FFFFFF", textAlign: "center", fontSize: "1.8vh" }}>

                                <tr>
                                    <td>{moment(rpFuelConsumptionListModel.FUEL_DATE).locale('en').format("DD MMM YYYY")}</td>
                                    <td style={{ fontWeight: "bold" }}>{numberFormat(rpFuelConsumptionListModel.FUEL_TARGET, 0)}</td>
                                    <td style={{ fontWeight: "bold" }}>{numberFormat(rpFuelConsumptionListModel.FUEL_ACTUAL, 0)}</td>
                                    <td style={{ color: Math.abs(rpFuelConsumptionListModel.FUEL_DIFF) > showValueCriteria.VALUE_CRITERIA_TODAY ? "#FF4545" : "#FFFFFF", fontWeight: "bold" }}>{numberFormat(rpFuelConsumptionListModel.FUEL_DIFF, 0)}</td>

                                    <td rowSpan={2}>
                                        <Col sm={12}>
                                            <Input
                                                placeholder={showValueCriteria.SHOW_TEXT}
                                                // placeholder="*บังคับต้องการกรอกค่า เมื่อ Target Actual รายวันแตกต่างกันเกิน"  {showValueCriteria}  "(สามารถปรับค่าได้)"
                                                type="textarea"
                                                rows="3"
                                                style={{ resize: "none", border: rpFuelConsumptionListModel.VALIDATE_FLAG != true ? "solid 1px #FFFFFF" : "solid 1px #FF4545", color: "#FFFFFF" }}  //FF3636
                                                className="form-control"
                                                disabled
                                                onChange={(e) => setRPFuelConsumptionListModel(
                                                    {
                                                        ...rpFuelConsumptionListModel,
                                                        CAUSE_REMARK: e.target.value
                                                    })
                                                }
                                                value={rpFuelConsumptionListModel.CAUSE_REMARK}
                                            />
                                            <span className="mt-1 mb-1" style={{ color: "#FFFFFF", fontSize: "1.8vh", fontWeight: "bold" }}>To day criteria : {numberFormat(showValueCriteria.VALUE_CRITERIA_TODAY, 0)}</span>
                                        </Col>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Accumulate Year( {moment(rpFuelConsumptionListModel.ACCUM_START).locale('en').format("DD MMM YYYY")} - {moment(rpFuelConsumptionListModel.ACCUM_END).locale('en').format("DD MMM YYYY")})</td>
                                    <td style={{ fontWeight: "bold" }}>{numberFormat(rpFuelConsumptionListModel.ACCUM_TARGET, 0)}</td>
                                    <td style={{ fontWeight: "bold" }}>{numberFormat(rpFuelConsumptionListModel.ACCUM_ACTUAL, 0)}</td>
                                    <td style={{ fontWeight: "bold" }}>{numberFormat(Math.abs(rpFuelConsumptionListModel.ACCUM_ACTUAL - rpFuelConsumptionListModel.ACCUM_TARGET), 0)}</td>
                                </tr>
                            </tbody>
                        </Table>
                        <Table className="table table-bordered mb-0 mt-1">
                            <thead>
                                <tr style={{ fontSize: "1.7vh" }}>
                                    <th style={{ backgroundColor: "#466597", color: "#FEF6AA", textAlign: "center", width: "35%", fontWeight: "bold" }}>Daily Flow</th>
                                    <th style={{ backgroundColor: "#466597", color: "#FEF6AA", textAlign: "center", width: "35%", fontWeight: "bold" }}>Fuel (Gas)</th>
                                    <th style={{ backgroundColor: "#466597", color: "#FEF6AA", textAlign: "center", width: "30%", fontWeight: "bold" }}>Fuel (Elec.)</th>
                                </tr>
                            </thead>
                            <tbody style={{ color: "#FFFFFF", textAlign: "center", fontSize: "1.8vh", fontWeight: "bold" }}>
                                <tr>
                                    <td>{numberFormat(rpFuelConsumptionListModel.DAILY_FLOW, 0)}</td>
                                    <td>{numberFormat(rpFuelConsumptionListModel.FUEL_GAS, 0)}</td>
                                    <td>{numberFormat(rpFuelConsumptionListModel.FUEL_ELEC, 0)}</td>
                                </tr>
                            </tbody>
                        </Table>
                    </div>
                </div>
            </div>


            {/* <div className="d-flex dashboard-content-body">
                <div className="d-flex flex-column" style={{ flex: 1.5 }}>
                    <div className="d-flex" style={{ flex: 1, margin: 5 }}>
                        <div style={{ minWidth: '100%' }} className="mt-0 me-1">
                            <BarChartQtyAndComFuel data={dataListGraphRpFuel} date={props.date} summaryReportPid={props.summaryReportPid} targetPlan={dailyTargetPlan} />
                        </div>
                    </div>
                </div>
            </div> */}
            {/* <Row className="mt-0">
                <Col sm="6" className="mt-0">
                    <Row>
                        <Col sm="2">
                            <h4 style={{ fontSize: "17px" }}> Quality </h4>
                        </Col>
                        <Col sm="2">
                            <h4 style={{ fontSize: "17px", color: qtyModel.QUALITY_STATUS == 1 ? "#FC0404" : "#11891E" }}> {qtyModel.QUALITY_STATUS == 1 ? "Abnormal" : "Normal"} </h4>
                        </Col>
                    </Row>
                    <Row>
                        <div className="table-responsive mt-0" style={{ height: "100%" }}>
                            hover-table-highlight
                            <Table className="table table-bordered mb-0" style={{ height: "100%" }}>
                                <thead>
                                    <tr>
                                        <th style={{ backgroundColor: "#5868b785", color: "#3AD5FF", textAlign: "center", width: "15%" }}>Quality</th>
                                        <th style={{ backgroundColor: "#667eef85", color: "#3AD5FF", textAlign: "center", width: "10%" }}>Status</th>
                                        <th style={{ backgroundColor: "#556ee678", color: "#3AD5FF", textAlign: "center", width: "25%" }}>Remark</th>
                                    </tr>
                                </thead>
                                <tbody style={{ color: "#FFFFFF", textAlign: "center" }}>
                                    <tr>
                                        <td>Offshore</td>
                                        <td style={{ color: qtyModel.OFFSHORE_STATUS == 1 ? "#FC0404" : "#11891E" }}>
                                            {qtyModel.OFFSHORE_STATUS == 1 ? "Abnormal" : "Normal"} </td>
                                        <td>{qtyModel.OFFSHORE_REMARK}</td>
                                    </tr>
                                    <tr>
                                        <td>East</td>
                                        <td style={{ color: qtyModel.EAST_STATUS == 1 ? "#FC0404" : "#11891E" }}>
                                            {qtyModel.EAST_STATUS == 1 ? "Abnormal" : "Normal"} </td>
                                        <td>{qtyModel.EAST_REMARK}</td>
                                    </tr>
                                    <tr>
                                        <td>West</td>
                                        <td style={{ color: qtyModel.WEST_STATUS == 1 ? "#FC0404" : "#11891E" }}>
                                            {qtyModel.WEST_STATUS == 1 ? "Abnormal" : "Normal"} </td>
                                        <td>{qtyModel.WEST_REMARK}</td>
                                    </tr>
                                    <tr>
                                        <td>East West</td>
                                        <td style={{ color: qtyModel.EASTWEST_STATUS == 1 ? "#FC0404" : "#11891E" }}>
                                            {qtyModel.EASTWEST_STATUS == 1 ? "Abnormal" : "Normal"} </td>
                                        <td>{qtyModel.EASTWEST_REMARK}</td>
                                    </tr>
                                    <tr>
                                        <td>South</td>
                                        <td style={{ color: qtyModel.SOUTH_STATUS == 1 ? "#FC0404" : "#11891E" }}>
                                            {qtyModel.SOUTH_STATUS == 1 ? "Abnormal" : "Normal"} </td>
                                        <td>{qtyModel.SOUTH_REMARK}</td>
                                    </tr>

                                </tbody>
                            </Table>
                        </div>
                    </Row>
                </Col>

                <Col sm="6" className="mt-0" style={{ borderLeft: "2px solid #4A5576" }}>

                    <h4 style={{ fontSize: "17px" }}>Compressor Fuel Consumption ( Flow Per Fuel)</h4>
                    <Row className="mt-0">
                        <BarChartQtyAndComFuel data={dataListGraphRpFuel} date={props.date} summaryReportPid={props.summaryReportPid} targetPlan={dailyTargetPlan} />
                    </Row>


                    <Row className="mt-0">
                        <Col lg="12">
                            <div className="table">
                                className="table-responsive"
                                hover-table-highlight

                                <Table className="table table-bordered mb-0">
                                    <thead>
                                        <tr>
                                            <th colSpan={7} style={{ backgroundColor: "#556ee64a", color: "#7AE3F7", textAlign: "center", width: "100%" }}>Compressor Fuel Consumption</th>
                                        </tr>
                                        <tr>
                                            <th style={{ backgroundColor: "#556ee678", color: "#7AE3F7", textAlign: "center", width: "20%" }}>Flow/Fuel (MMSCF/BBTU)</th>
                                            <th style={{ backgroundColor: "#667eef85", color: "#7AE3F7", textAlign: "center", width: "15%" }}>Target</th>
                                            <th style={{ backgroundColor: "#5868b785", color: "#7AE3F7", textAlign: "center", width: "15%" }}>Actual</th>
                                            <th style={{ backgroundColor: "#667eef85", color: "#7AE3F7", textAlign: "center", width: "15%" }}>Diff</th>
                                            <th style={{ backgroundColor: "#5868b785", color: "#7AE3F7", textAlign: "center", width: "35%" }}>Cause</th>
                                        </tr>
                                    </thead>
                                    <tbody style={{ color: "#FFFFFF", textAlign: "center" }}>

                                        <tr>
                                            <td>{moment(rpFuelConsumptionListModel.FUEL_DATE).locale('en').format("DD MMM YYYY")}</td>
                                            <td>{numberFormat(rpFuelConsumptionListModel.FUEL_TARGET, 2)}</td>
                                            <td>{numberFormat(rpFuelConsumptionListModel.FUEL_ACTUAL, 2)}</td>
                                            <td style={{ color: rpFuelConsumptionListModel.FUEL_DIFF > showValueCriteria.VALUE_CRITERIA_TODAY ? "#FF2F21" : "#FFFFFF" }}>{numberFormat(rpFuelConsumptionListModel.FUEL_DIFF, 2)}</td>
                                            <td rowSpan={2}>
                                                <Col sm={12}>
                                                    <Input
                                                        placeholder={showValueCriteria.SHOW_TEXT}
                                                        placeholder="*บังคับต้องการกรอกค่า เมื่อ Target Actual รายวันแตกต่างกันเกิน"  {showValueCriteria}  "(สามารถปรับค่าได้)"
                                                        type="textarea"
                                                        rows="3"
                                                        style={{ border: rpFuelConsumptionListModel.VALIDATE_FLAG != true ? "solid 1px #FFFFFF" : "solid 1px #FF3636", color: "#FFFFFF" }}  //FF3636
                                                        className="form-control"
                                                        disabled
                                                        onChange={(e) => setRPFuelConsumptionListModel(
                                                            {
                                                                ...rpFuelConsumptionListModel,
                                                                CAUSE_REMARK: e.target.value
                                                            })
                                                        }
                                                        value={rpFuelConsumptionListModel.CAUSE_REMARK}
                                                    />
                                                    <span className="mt-1 mb-1" style={{ color: "#FFFFFF", fontSize: "15px" }}>To day criteria : {numberFormat(showValueCriteria.VALUE_CRITERIA_TODAY, 0)}</span>
                                                </Col>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Accumulate Year( {moment(rpFuelConsumptionListModel.ACCUM_START).locale('en').format("DD MMM YYYY")} - {moment(rpFuelConsumptionListModel.ACCUM_END).locale('en').format("DD MMM YYYY")})</td>
                                            <td>{numberFormat(rpFuelConsumptionListModel.ACCUM_TARGET, 2)}</td>
                                            <td>{numberFormat(rpFuelConsumptionListModel.ACCUM_ACTUAL, 2)}</td>
                                            <td>{numberFormat(Math.abs(rpFuelConsumptionListModel.ACCUM_TARGET - rpFuelConsumptionListModel.ACCUM_ACTUAL), 2)}</td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </div>

                            <div className="table mt-0">
                                className="table-responsive
                                hover-table-highlight
                                <Table className="table table-bordered mb-0">
                                    <thead>
                                        <tr>
                                            <th style={{ backgroundColor: "#556ee678", color: "#7AE3F7", textAlign: "center", width: "35%" }}>Daily Flow</th>
                                            <th style={{ backgroundColor: "#667eef85", color: "#7AE3F7", textAlign: "center", width: "35%" }}>Fuel (Gas)</th>
                                            <th style={{ backgroundColor: "#5868b785", color: "#7AE3F7", textAlign: "center", width: "30%" }}>Fuel (Elec.)</th>
                                        </tr>
                                    </thead>
                                    <tbody style={{ color: "#FFFFFF", textAlign: "center" }}>
                                        <tr>
                                            <td>{numberFormat(rpFuelConsumptionListModel.DAILY_FLOW, 2)}</td>
                                            <td>{numberFormat(rpFuelConsumptionListModel.FUEL_GAS, 2)}</td>
                                            <td>{numberFormat(rpFuelConsumptionListModel.FUEL_ELEC, 2)}</td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </div>
                        </Col>
                    </Row>
                </Col>
            </Row> */}

        </Row >
    )
}

SectionQtyAndComFuel.propTypes = {
    t: PropTypes.any,
    date: PropTypes.any,
    summaryReportPid: PropTypes.any,
}

export default SectionQtyAndComFuel
